module.exports = __webpack_public_path__ + "media/src/application/media/animation/step-5-58aa1d9d5966572160a44d8eb68592e7.svg";